import config from './config.api';
import patient from './patient.api';
import document from './document.api';
import references from './references.api';
import synchub from './synchub.api';

const api = {
  config,
  patient,
  document,
  references,
  synchub,
};

export { config, patient, document, references, synchub };

export default api;
